import { render } from "./Opinion.vue?vue&type=template&id=41ff5c3c"
import script from "./Opinion.vue?vue&type=script&lang=js"
export * from "./Opinion.vue?vue&type=script&lang=js"

import exportComponent from "D:\\fitbar\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__